import { RecuperarPassModalComponent } from './recuperarPassword/recuperarPass.component';
import { Component, OnInit, Input, Inject, ViewChild, ElementRef, Injectable } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { LoginObject } from '../../models/login-object';
import { AuthenticationService } from '../../services/authentication.service';
import { SearchInvoicesService } from '../../services/search-invoices.service';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';
import { Session } from '../../models/session';
import { timeout } from 'q';
import {TranslateService} from '@ngx-translate/core';
import {LOCAL_STORAGE, WebStorageService} from 'angular-webstorage-service';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { count } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { CryptoService } from '../../security/crypto.service';
import { passwordValidator } from '../../shared/validators/password.validator';


const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};

@Injectable()
export class I18n {
  lang; language;
  constructor(
     @Inject (LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    // console.log(this.storage.get('LOCAL_STORAGE'));
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en'; 
    }
  }
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [NgbActiveModal, I18n, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}]
})
export class LoginComponent implements OnInit {
  @ViewChild('UploadModal') UploadModal: ElementRef;
  @ViewChild('popover') popover: NgbPopover | undefined; // popover de requisitos de contraseña

  public loginForm: FormGroup;
  public registerForm: FormGroup;
  public consultaForm: FormGroup;
  public submitted: Boolean = false;
  public error = null;
  sinSoporte: boolean = false;
  mensaje: any;
  badLogin = false;
  busy: boolean = false;
  usuarioInvalido: null;
  dia;
  tarde;
  noche;
  activarReg: boolean = false;
  registro = {
    tipo: 'C',
    rfcUsuario : null,
    nombreUsuario : null,
    passUsuario : null,
    cpassUsuario : null,
    telefonoUsuario : null,
    direccionUsuario : null,
    correoUsuario : null,
  }
  registroInvalido: boolean = false;
  modalRespuesta;
  mensajeRespuesta: any;
  closeResult: string;
  activarConsulta: boolean = false;
  consulta = {
    rfcConsulta: null,
    remisionConsulta: null
  }
  camposVacios: boolean = false;
  modalReference;

  dLn;
  valueLn;
  msjErrorServidor;
  usuarioId;

  navegadorNoValido;
  navegadorNoValidoIE;

  constructor(
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private facturaRemService: SearchInvoicesService,
    private storageService: StorageService,
    private activeModal: NgbActiveModal,
    
    private modalService: NgbModal,
    @Inject (LOCAL_STORAGE) private storage: WebStorageService,
    private router: Router,
    private cryptoService: CryptoService
  ) {
      // console.log('constr');
      this.storage.remove('LOCAL_STORAGE');
      const ln = window.navigator.language;
      this.valueLn = ln.substring(0, 2);
      translate.use(this.valueLn);
      this.storage.set('LOCAL_STORAGE', this.valueLn);
      this.translate.get('texto.mensajeErrorServidor').subscribe(
        text => {
        this.msjErrorServidor = text;
      });
      this.translate.get('texto.navegadorNoValido').subscribe(
        text => {
          this.navegadorNoValido = text;
      });
      this.translate.get('texto.navegadorNoValidoIE').subscribe(
        text => {
          this.navegadorNoValidoIE = text;
          this.validarNavegador();
      });
  }

  validarNavegador() {
    // validacion de la version minima del navegador
    // El arreglo supportNav contiene las versiones minimas 
    // del navegador que seran aceptadas
    var supportNav = [
      {explorador: 'Opera', version: '41'},// 41.0.2
      {explorador: 'Chrome', version: '48'},// 48.0.2564.97
      {explorador: 'Safari', version: '3'},// 3.2.1
      {explorador: 'Firefox', version: '50'},// 50.0.2
      {explorador: 'Edge', version: '15'},// 15.15063
    ];
    ///////// Funcion con expresion regular para recuperar version del navegador /////////
    var getBrowserInfo = function() {
      var ua= navigator.userAgent, tem, 
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    };
    /////////////////////////////////////////////////////////////////////////
    let versionFull = getBrowserInfo();
    let verSplit = versionFull.split(' ');

    if (versionFull.indexOf('IE') == 0) {
      this.sinSoporte = true; 
      alert(`Nav: ${versionFull}\n` + this.navegadorNoValidoIE );
    }
    supportNav.forEach(element => {
       if (element.explorador == verSplit[0]) {
        if (Number(verSplit[1]) < Number(element.version)) {
          this.sinSoporte = true;
          alert(`Nav: ${versionFull}\n` + this.navegadorNoValido);
        }
       }
    });
  }

  ngOnInit() {
    this.hideModal();
    
    const regexPattern = /^[0-9]+(.[0-9]{0,2})?$/;

    this.cambiarMensaje();
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.registerForm = this.formBuilder.group({
      rfc: ['', Validators.required],
      nombre: ['', Validators.required],
      contrasena: ['', [Validators.required, passwordValidator]],
      confcontrasena: ['', Validators.required],
      telefono: ['', Validators.compose([Validators.required, Validators.max(999999999999999999999999999999999999999999999), Validators.pattern(regexPattern)])],
      direccion: ['', Validators.required],
      correo: ['',  Validators.compose([Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),
        Validators.minLength(1)])]
    });
    this.consultaForm = this.formBuilder.group({
      rfcConsulta: ['', Validators.required],
      remisionConsulta: ['', Validators.required],
      fechaConsulta: ['', Validators.required]
    });
    
  }

  useLanguage(event, language: string) {
    this.storage.remove('LOCAL_STORAGE');
    const selectElement = event.target;
    this.valueLn = selectElement.value;
    this.translate.use(this.valueLn);
    this.storage.set('LOCAL_STORAGE', this.valueLn);
    this.cambiarMensaje();
  }

  public hideModal() {
    
    if(this.UploadModal) {
    this.UploadModal.nativeElement.hide();   
    } else {
      // console.log('nooo"');
    }   
  }

  public submitLogin(): void {
    this.busy = true;
    this.submitted = true;
    this.error = null;
    
    if (this.loginForm.valid) {

      this.authenticationService.login(new LoginObject(this.loginForm.value), this.valueLn).subscribe(
        data => {
          this.busy = false;
          // console.log(data);

          if (data != null) {
            // se guarda serverTime para sincronizar el reloj
            if (data && data.serverTime) this.cryptoService.setServerTime(data.serverTime);

            let session = {
              usuario: data,
              token: this.create_UUID()
            }
             this.correctLogin(session)

             this.usuarioId = data.userId;
             
            }else{
              this.badLogin = true;
            }
        },
        error => {
          console.log(error);
          if(error.status == 401){
            this.usuarioInvalido = error.error.mensaje;
          }
          this.error = error;
          this.busy = false;
        }
      )
    }else{
      // console.log('campos incompletos');
      this.busy = false;
      this.badLogin = true;
    }
  }

  // private correctLogin(data: Session, token: String) {
  //   console.log(data);
  //   if (data != null) {
  //     this.storageService.setCurrentSession(data, token);
  //     this.router.navigate(['/home/inicio']);
  //   } else {
  //   }
  // }
  
  private correctLogin(data: Session) {
    // console.log(data);
    if (data != null) {
      this.storageService.setCurrentSession(data);
      this.router.navigate(['/home/inicio']);
      /* if (navigator.geolocation) {
        alert('siii');
       } else {
           alert("Tu navegador no soporta la geolocalización, actualiza tu navegador.");
       }  */
    } else {
    }
  }

   create_UUID() {
    var dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = (dt + Math.random()*16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r :(r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}

clearLogin() {
  this.badLogin = null;
}
cambiarMensaje() {
  const a = new Date();
  const hora = a.getHours();

  if (this.valueLn === 'en' || this.valueLn !== 'es') {
    if (hora >= 19 && hora <= 24) {
      this.mensaje = 'good evening!';
    } else if (hora >= 0 && hora <= 4) {
      this.mensaje =  'good morning!';
    } else if (hora >= 5 && hora <= 11) {
      this.mensaje =  'good morning!';
    } else if (hora >= 12 && hora <= 18) {
      this.mensaje =  'good afternoon!';
    }
  } else if (this.valueLn === 'es') {
    if (hora >= 19 && hora <= 24) {
      this.mensaje = 'buenas noches!';
    } else if (hora >= 0 && hora <= 4) {
      this.mensaje =  'buenos días!';
    } else if (hora >= 5 && hora <= 11) {
      this.mensaje =  'buenos días!';
    } else if (hora >= 12 && hora <= 18) {
      this.mensaje =  'buenas tardes!';
    }
  }

}

activarRegistro() {
  this.activarReg = !this.activarReg;
  this.registerForm.reset();
}

limpiarCampos() {
  this.registro = {
    tipo : 'P',
    rfcUsuario : '',
    nombreUsuario : '',
    passUsuario : '',
    cpassUsuario : '',
    telefonoUsuario : '',
    direccionUsuario : '',
    correoUsuario : '',
  }
}

recuperarPass() {
  const modalRef = this.modalService.open(RecuperarPassModalComponent, {size: 'lg', keyboard: false, centered: true, backdrop: 'static'});
}

submitRegister(respuesta) {
  // console.log(this.registerForm);

  if (this.registerForm.valid) {

    this.registro.rfcUsuario = this.registro.rfcUsuario.trim();
    this.registro.nombreUsuario = this.registro.nombreUsuario.trim();
    this.registro.passUsuario = this.registro.passUsuario.trim();
    this.registro.cpassUsuario = this.registro.cpassUsuario.trim();
    this.registro.correoUsuario = this.registro.correoUsuario.trim();
    this.registro.direccionUsuario = this.registro.direccionUsuario.trim();
 
    this.registroInvalido = false;
    this.busy = true;

    this.authenticationService.crearRegistro(this.registro, this.valueLn).subscribe(
      data => {
        this.busy = false;
        // console.log(data);
        this.registerForm.reset();
        if (data != null) {
          this.mensajeRespuesta = data.mensaje;
          this.openRespuesta(respuesta);

          if (data.mensaje == 'Solicitud de registro exitosa.') {
            this.activarReg = !this.activarReg;
            this.limpiarCampos();
          } 

        }else{ 
          // console.log('error...')
        } 
      },
      error => {
        console.log(error);
        
        this.busy = false;
        if (error.status === 401) {
          this.storageService.openLogout();
        } else {
          // console.log(error);
        }
        if (error.status === 500) {
          
          this.mensajeRespuesta = error.error.mensaje;
          this.openRespuesta(respuesta);
          
        } else {
          this.mensajeRespuesta = error.error.respuesta.mensaje;
          this.openRespuesta(respuesta);
        }
      }
    )

  } else{
    this.registroInvalido = true;
  }
}

openRespuesta(respuesta) {
  this.modalRespuesta = this.modalService.open(respuesta, {centered: true, keyboard: false, backdrop: 'static'});
  this.modalRespuesta.result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}

private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return  `with: ${reason}`;
  }
}

activarConsultaFacturas() {
  this.activarConsulta = !this.activarConsulta;
}

  telInvalid: boolean = true;
  checkNumber() {
    if (this.registerForm.controls.telefono.hasError('max')) {
      this.telInvalid = false;
    } else {
      this.telInvalid = true;
    }
  }

  // validaciones de contraseña segura
  passwordHasError(errorKey: string): boolean {
    const passwordControl = this.registerForm.get('contrasena');
    if (!passwordControl || !passwordControl.errors) {
      return true; // no hay error
    }

    return !passwordControl.errors[errorKey];
  }

  get hasMinLength(): boolean { return this.passwordHasError('minLength') }
  get hasUppercase(): boolean { return this.passwordHasError('noUppercase') }
  get hasLowercase(): boolean {  return this.passwordHasError('noLowercase') }
  get hasNumber(): boolean {  return this.passwordHasError('noNumber') }
  get hasSpecialChar(): boolean { return this.passwordHasError('noSpecial') }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts